module.exports = __webpack_public_path__ + "img/NWEBANNER.66ccf09e.jpg";